import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imgZoom',
  standalone: true
})
export class ImgZoomPipe implements PipeTransform {

  transform(value: string | undefined, ...args: unknown[]): string {
    // if (value) {
    //   let index = value.indexOf('<img');
    //   if (index && index != -1 && value.length) {
    //     let pos = 0;
    //     let arr = value.split('');
    //     arr?.splice(0, 0, '<div id="MaxImg"></div> ');
    //     value = arr?.join('');
    //     while (pos < value.length && index != -1) {
    //       arr = value.split('');
    //       index = value.indexOf('<img', pos);
    //       if (index && index != -1) {
    //         arr?.splice(index + 4, 0, ' class="MinImg" ');
    //         pos = index + 5;
    //       }
    //       value = arr?.join('');
    //     }
    //   }
    //   return value;
    // }
    if (value && value.length) {
      let index = value.indexOf('<img');
      if (index && index != -1) {
        let pos = 0;
        let arr = [];
       // arr?.splice(0, 0, '<div id="MaxImg"></div> ');
       // value = arr?.join('');
        while (pos < value.length && index != -1) {
          arr = value.split('');
          index = value.indexOf('<img', pos);
          if (index && index != -1) {
            arr?.splice(index + 4, 0, ' class="MinImg" ');
            pos = index + 5;
          }
          value = arr?.join('');
        }
      }
      return value;
    }
    return '';

  }

}
